




















































































































































import Vue from 'vue'

import {
  staticitems,
  mdvHeaders
} from '../example-data'

const sandboxTemplateHTML =
`<v-md-view
          :items="items"
          :dark="dark"
          :headers="mdvHeaders"
          :selectable="selectable"
          :multiple="multiple"
          :dense="dense"
          :hierarchy = "hierarchy"
          :items-per-page = 5
          header-icon = "mdi-settings"
          upIcon = "mdi-arrow-expand-up"
          downIcon = "mdi-arrow-expand-down"
          filterIcon = "mdi-text-subject"
          filterActiveIconColor = "red"
        >
          <template v-if="customSlots" v-slot:prependTree="{ item, open }">
            <v-icon >{{ open ? "mdi-folder-open" : "mdi-folder" }}</v-icon>
          </template>
          <template v-if="customSlots" v-slot:itemTable.data-table-select="{ isSelected, select }">
            <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
          </template>
</v-md-view>`

const sandboxCode =
`export default ({
  data: () => ({
    items: staticitems, // see items
    mdvHeaders: mdvHeaders, // see headers
    selectable: true,
    multiple: false,
    dense: false,
    dark: false,
    customSlots: false,
    hierarchy: false
  })
})`

export default Vue.extend({
  data: () => ({
    items: staticitems,
    mdvHeaders: mdvHeaders,
    selectable: true,
    multiple: false,
    dense: false,
    dark: false,
    customSlots: false,
    hierarchy: false,
    folderIcon: 'mdi-folder',
    folderOpenIcon: 'mdi-folder-open',
    itemIcon: 'mdi-file',
    itemIconColor: 'cyan',
    folderIconColor: 'amber',

    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML,
    sandboxCode: sandboxCode

  })
})
